import { SofaIcon } from './SofaIcon';

/**
 * author: Michael Irigoyen
 * id 5560ABF9-E635-4D73-A39B-5404443F099F
 * name sofa
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sofa.svg
 * tags
 * - Home Automation 
 */
export const CouchIcon = SofaIcon;
export default CouchIcon